// import Pusher from 'pusher-js' // Broken import :/ using window for now
import "pusher-js";
import Pusher from "pusher-js";

export const connect = (key: string, cluster: string, token: string) => {
  return new Pusher(key, {
    cluster,
    authEndpoint: `${process.env.VUE_APP_BOOST_NOW_BASE_URL}/admin/boost_now/socket_auth`,
    auth: {
      params: { token },
      headers: {}
    }
  });
};
